/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdherenceReportRangeDto
 */
export interface AdherenceReportRangeDto {
    /**
     * 
     * @type {Date}
     * @memberof AdherenceReportRangeDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdherenceReportRangeDto
     */
    endDate: Date;
}

/**
 * Check if a given object implements the AdherenceReportRangeDto interface.
 */
export function instanceOfAdherenceReportRangeDto(value: object): value is AdherenceReportRangeDto {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function AdherenceReportRangeDtoFromJSON(json: any): AdherenceReportRangeDto {
    return AdherenceReportRangeDtoFromJSONTyped(json, false);
}

export function AdherenceReportRangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdherenceReportRangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
    };
}

export function AdherenceReportRangeDtoToJSON(json: any): AdherenceReportRangeDto {
    return AdherenceReportRangeDtoToJSONTyped(json, false);
}

export function AdherenceReportRangeDtoToJSONTyped(value?: AdherenceReportRangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': ((value['endDate']).toISOString().substring(0,10)),
    };
}

